import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MetalRateStrip from '../components/MetalRateStrip';
import CategorySection from '../components/CategorySection';
import SegmentationSection from '../components/SegmentationSection';
import MetalRatesSection from '../components/MetalRatesSection';
import OnboardingModal from '../components/OnboardingModal';

const CategoriesPage = () => {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authModalRole, setAuthModalRole] = useState('buyer');

  const openAuth = (role) => {
    setAuthModalRole(role);
    setAuthModalOpen(true);
  };

  return (
    <div className="app-wrapper">
      <MetalRateStrip />
      <Navbar onOpenAuthModal={openAuth} />

       <main style={{ paddingBottom: '60px' }}>
        <div className="jmi-container" style={{ paddingTop: '60px', textAlign: 'center' }}>
          <div className="section-label">B2B WHOLESALE SECTORS</div>
          <h1 className="section-title">
            Jewellery Categories & <span className="gold-gradient-text">Specifications</span>
          </h1>
          <p className="section-subtitle">
            Explore hallmarked wholesale collections across gold, silver, diamond, platinum, gemstones, and pearls 
            with transparent making charge structures and live bullion valuation.
          </p>
        </div>

        <CategorySection />
        <SegmentationSection />
        <MetalRatesSection />
      </main>

      <Footer onOpenAuthModal={openAuth} />
      <OnboardingModal 
        isOpen={authModalOpen} 
        onClose={() => setAuthModalOpen(false)} 
        initialRole={authModalRole} 
      />
    </div>
  );
};

export default CategoriesPage;
